import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import PageLoader from '@/components/base/PageLoader';

type Role = 'welfare_user' | 'welfare_staff' | 'welfare_admin' | 'welfare_supervisor' | 'general_user' | 'general_admin';

interface DenyRolesGuardProps {
  /** アクセスを拒否するロールのリスト */
  deniedRoles: Role[];
  /** 拒否ロールをリダイレクトする先 */
  redirectTo: string;
  /** ロールごとにリダイレクト先を分けたい場合の上書きマップ */
  redirectByRole?: Partial<Record<Role, string>>;
}

/**
 * 特定ロールのアクセスを拒否するガード。
 * AuthGuard の内側（＝ログイン済み）で使用する。
 * 現場機能（勤怠・作業・支援記録・相談窓口・面談・職員日報）を
 * 福祉事業管轄ロールから遮断するために使う。
 */
export default function DenyRolesGuard({ deniedRoles, redirectTo, redirectByRole }: DenyRolesGuardProps) {
  const { profile, loading } = useAuth();

  if (loading) {
    return <PageLoader />;
  }

  if (profile && deniedRoles.includes(profile.role as Role)) {
    const target = redirectByRole?.[profile.role as Role] ?? redirectTo;
    return <Navigate to={target} replace />;
  }

  return <Outlet />;
}